



































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { FilterConditions, VariableValue } from '../../../core/models';
import ConditionsStore, { ConditionsState } from './conditions.state';
import { pluckAndStartWatch } from '../../../core/operators';
import { tap } from 'rxjs/operators';
import { isPositiveFloatNumber } from '../../../core/utils';
import { FilterType } from '../../utils';

@Component<Condition>({
    subscriptions() {
        return {
            variables$: this.$watchAsObservable('variables').pipe(
                pluckAndStartWatch([]),
                tap((variables: VariableValue[]) => this.store.updateVariable(variables[0]))
            ),
            variableSelected$: this.store.variable$,
            filterType$: this.store.filterType$,
            greaterThan$: this.store.greaterThan$,
            lessThan$: this.store.lessThan$,
            equalTo$: this.store.equalTo$,
            range$: this.store.range$,
            min$: this.store.min$,
            max$: this.store.max$,
            exact$: this.store.exact$,
            unit$: this.store.unit$
        };
    }
})
export default class Condition extends Vue {
    @Prop({ default: () => () => [] }) variables: VariableValue[];
    store: ConditionsStore = new ConditionsStore();
    filterTypes: FilterType[] = [FilterType.EQUAL_TO, FilterType.GREATER_THAN, FilterType.LESS_THAN, FilterType.RANGE];
    variableSelected$: VariableValue;
    filterType$: FilterType;
    min$: string;
    max$: string;
    exact$: string;
    unit$: string;
    validCondition: boolean = false;
    greaterThan$: boolean;
    lessThan$: boolean;
    equalTo$: boolean;
    range$: boolean;
    validateForm: boolean = false;

    isMaxGreaterThan(max: string): boolean {
        return +this.min$ < +max;
    }

    isMinLessThan(min: string): boolean {
        return +this.max$ > +min;
    }

    handleVariableSelect(select: VariableValue): void {
        this.store.updateVariable(select);
        this.disableValidationForm();
    }

    handleFilterTypeSelect(select: FilterType): void {
        this.store.updateFilterType(select);
        this.disableValidationForm();
    }

    handleMin(min: string): void {
        this.store.updateMin(min);
        this.disableValidationForm();
    }

    handleMax(max: string): void {
        this.store.updateMax(max);
        this.disableValidationForm();
    }

    handleExact(exact: string): void {
        this.store.updateExact(exact);
        this.disableValidationForm();
    }

    setFirstVariable(): void {
        this.store.updateVariable(this.variables[0]);
    }

    setFirstFilterType(): void {
        this.store.updateFilterType(FilterType.RANGE);
    }

    clearInputs() {
        this.store.reset();
    }

    clear(): void {
        this.clearInputs();
        this.setFirstVariable();
        this.setFirstFilterType();
    }

    getState(): ConditionsState {
        return this.store.selectSnapshot<ConditionsState>(store => store);
    }

    getFilterCondition(): FilterConditions | null {
        const state = this.getState();
        return state.condition;
    }

    updateFilterCondition(condition: FilterConditions): void {
        this.store.updateCondition(condition);
    }

    get form(): HTMLFormElement {
        return this.$refs.form as HTMLFormElement;
    }

    validate(): Promise<boolean> {
        this.validateForm = true;
        return this.$nextTick().then(() => this.form.validate());
    }
    reset() {
        this.form.reset();
    }
    resetValidation() {
        this.disableValidationForm();
        this.form.resetValidation();
    }

    disableValidationForm(): void {
        this.validateForm = false;
    }

    get greaterThan(): HTMLInputElement {
        return this.$refs.greaterThan as HTMLInputElement;
    }

    get lessThan(): HTMLInputElement {
        return this.$refs.lessThan as HTMLInputElement;
    }

    get equalTo(): HTMLInputElement {
        return this.$refs.equalTo as HTMLInputElement;
    }

    get rangeGreaterThan(): HTMLInputElement {
        return this.$refs.rangeGreaterThan as HTMLInputElement;
    }

    setFocus(): void {
        if (this.greaterThan$) {
            this.greaterThan.focus();
        } else if (this.lessThan$) {
            this.lessThan.focus();
        } else if (this.equalTo$) {
            this.equalTo.focus();
        } else if (this.range$) {
            this.rangeGreaterThan.focus();
        }
    }

    get minRules(): any[] {
        return this.validateForm
            ? [v => !!v || 'valor requerido', v => isPositiveFloatNumber(v) || 'valor inválido']
            : [];
    }

    get maxRules(): any[] {
        return this.validateForm
            ? [
                  v => !!v || 'valor requerido',
                  v => isPositiveFloatNumber(v) || 'valor inválido',
                  v => this.isMaxGreaterThan(v) || 'no puede ser menor que el valor mínimo'
              ]
            : [];
    }

    get exactRules(): any[] {
        return this.validateForm
            ? [v => !!v || 'valor requerido', v => isPositiveFloatNumber(v) || 'valor inválido']
            : [];
    }
}
